import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    // 301-style redirect to homepage (client-side equivalent)
    navigate("/", { replace: true });
  }, [location.pathname, navigate]);

  // Return null as we're redirecting immediately
  return null;
};

export default NotFound;
